import axios from "axios";
function createAxiosAuthMiddleware() {
  return ({ getState }: { getState: any }) =>
    (next: (arg0: any) => any) =>
    (action: any) => {
      if (getState().bMCProfile.idToken) {
        const token = getState().bMCProfile.idToken;
        axios.defaults.headers.common.Authorization = token
          ? `Bearer ${token}`
          : null;
      }
      axios.defaults.withCredentials = true; // Enable sending cookies globally
      return next(action);
    };
}

const axiosAuth = createAxiosAuthMiddleware();

export default axiosAuth;
